// Typelizer digest 10cb1c68ee50268f8b36226185e43765
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** POST /passwords */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/passwords', {}, options),
    method: 'post',
  }),

  /** GET /passwords/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/passwords/new', {}, options),
    method: 'get',
  }),

  /** GET /passwords/:token/edit */
  edit: (
    params: { token: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/passwords/:token/edit', params, options),
    method: 'get',
  }),

  /** PATCH /passwords/:token */
  update: (
    params: { token: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/passwords/:token', params, options),
    method: 'patch',
  }),
}
